import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { redirect_URL } from '../config';

export function useReferralUrl() {
  const { search } = useLocation();

  useEffect(() => {
    if (search) {
      localStorage.setItem('referralURL', search);
      return;
    }

    const referrer = document.referrer;
    if (!referrer || referrer.includes(redirect_URL) || referrer.includes('.stripe.com')) return;

    localStorage.setItem('referralURL', referrer);
  }, [search]);
}
